import React from 'react';
import Api from './Api';

const ApiContext = React.createContext(new Api('', ''));

export default ApiContext;
